<div class="mobile-content-wrapper">
  <div class="container mt-lg-4 mt-0">
    <fgb-tab
      [tabs]="['games.tab.live.upcoming' | translate, 'games.tab.results' | translate]"
      (tabSelectionChange)="onTabChage($event)"
    ></fgb-tab>
  </div>
  <div class="container mt-4">
    <ng-container *ngIf="gamesGroup$ | async as gamesGroup; else shimmerEffect">
        <fgbcl-games-group-list
          [gamesGroup]="gamesGroup"
          [groupType]="groupType"
          [filters]="filters"
          [sort]="sort"
          [default]="false"
          [liveUpcomingTab]="liveUpcomingTab"
        ></fgbcl-games-group-list>
    </ng-container>
  </div>
</div>

<ng-template #shimmerEffect>
  <div class="row">
    <div class="col-12 col-lg-4 mb-lg-4" *ngFor="let i of [1, 2, 3]">
      <div class="card" aria-hidden="true">
        <svg
          class="bd-placeholder-img card-img-top"
          width="100%"
          height="130"
          xmlns="http://www.w3.org/2000/svg"
          role="img"
          aria-label="Placeholder"
          preserveAspectRatio="xMidYMid slice"
          focusable="false"
        >
          <title>Placeholder</title>
          <rect width="100%" height="100%" fill="#dedddd"></rect>
        </svg>
        <div class="card-body d-flex flex-column justify-content-between">
          <div>
            <h6 class="card-title placeholder-glow">
              <span class="placeholder col-6"></span>
            </h6>
            <p class="card-text placeholder-glow">
              <span class="placeholder col-7"></span>
            </p>
          </div>
          <button class="btn btn-primary disabled placeholder w-100"></button>
        </div>
      </div>
    </div>
  </div>
</ng-template>